import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { BranchesPayload } from '../BranchesState';

export const useAddBranches = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (branches: BranchesPayload) => {
      dispatch({
        type: 'ADD_BRANCHES',
        payload: {
          branches,
        },
      });
    },
    [dispatch],
  );
};
